export enum PaginationOption {
  PAGE = 'page',
  SORT_BY = 'sortBy',
  ORDER = 'order',
  PROGRESS = 'progress',
  SEARCH = 'search',
  OWNERS = 'owners',
}
